import { Formik } from 'formik';
import { TextField } from '../../components/forms/TextField';
import { Autocomplete } from '../../components/forms/Autocomplete';
import { countries } from 'bloggers-backend/lib/leads/dicts/countries';
import ButtonWithLoading from '../../components/forms/SubmitButton';
import { statuses } from 'bloggers-backend/lib/leads/dicts/statuses';
import { UserField } from '../../components/forms/UserField';
import Comments from '../../components/forms/Comments';
import { Column } from '../../components/forms/Column';
import { History } from '../../components/forms/History';
import { NewEmailDialog } from '../../components/NewEmailDialog';
import { Lead } from 'bloggers-backend/lib/leads/domain';
import { useEditForm } from '../../components/forms/hooks/useEditForm';
import { Row } from '../../components/forms/Row';
import { DeleteFlow } from '../../components/DeleteFlow';
import { EditFormLoader } from '../../components/forms/EditFormLoader';


export default function EditLeadPage() {
  const {loading, loadedData, update, isSubmitLoading, validate, deleteEntity} = useEditForm<Lead>('leads', '/leads');
  
  return (
    <EditFormLoader loading={loading} loadedData={loadedData}>
      <Formik
        initialValues={loadedData}
        onSubmit={update}
        validate={validate}
      >
        {({values, submitForm}) => (
          <Row>
            <Column>
              <h2>Edit lead: {values.name}</h2>

              <TextField required name="name" label="name"/>
              <TextField required name="category" label="category"/>
              <Autocomplete required name="status" label="status" options={statuses}/>
              <Autocomplete required name="country" label="country" options={countries}/>
              <TextField required name="website" label="website"/>
              <TextField required name="email" label="email"/>
              <UserField name="manager" label="manager"/>

              <TextField name="additionalEmail" label="additional email"/>
              <TextField name="socialMedia" label="social media"/>
              
              <ButtonWithLoading loading={isSubmitLoading} onClick={submitForm}/>
              <DeleteFlow deleteWhat="Lead" deleteAction={deleteEntity}/>
            </Column>
            <Column>
              <Comments
                    name="comments"
                    onCommentsSubmit={submitForm}
                    loading={isSubmitLoading}
                    notifications={{entity: {type: "lead", id: values.id, name: values.name}}}
              />
              <History history={values.history}/>
            </Column>
            <Column>
              <h2>Emails</h2>
              <NewEmailDialog mail={{to: values.email}}/>
            </Column>
          </Row>
        )}
      </Formik>
    </EditFormLoader>
  );
}
